import type { HTMLAttributes, ReactNode } from "react";

type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  /** Max width preset. Defaults to `xl` (max-w-7xl). */
  size?: "md" | "lg" | "xl" | "2xl";
};

const SIZES = {
  md: "max-w-3xl",
  lg: "max-w-5xl",
  xl: "max-w-7xl",
  "2xl": "max-w-[1440px]",
} as const;

export function Container({
  children,
  size = "xl",
  className = "",
  ...rest
}: ContainerProps) {
  return (
    <div
      {...rest}
      className={`mx-auto w-full ${SIZES[size]} px-5 sm:px-8 ${className}`}
    >
      {children}
    </div>
  );
}
